import * as Types from 'src/actions/project/comments/create/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { RootState } from 'src/reducers/RootReducer';
import ProjectComment from 'src/entities/ProjectComment';
import ValidatorService from 'src/services/validation/Validation.service';

export interface CreateProjectCommentAttempt extends Action {
  type: Types.CREATE_PROJECT_COMMENT_ATTEMPT;
}

export interface CreateProjectCommentSuccess extends Action {
  type: Types.CREATE_PROJECT_COMMENT_SUCCESS;
}

export interface CreateProjectCommentFailure extends Action {
  type: Types.CREATE_PROJECT_COMMENT_FAILURE;
  payload: {};
}

export type CreateProjectCommentAction =
  CreateProjectCommentAttempt
  | CreateProjectCommentSuccess
  | CreateProjectCommentFailure;

export interface CreateProjectCommentThunk extends ThunkAction<Promise<CreateProjectCommentAction>, RootState, string> {
}

export const createProjectCommentAttempt: ActionCreator<CreateProjectCommentAttempt> = () => (
  {
    type: Types.CREATE_PROJECT_COMMENT_ATTEMPT
  }
);

export const createProjectCommentSuccess: ActionCreator<CreateProjectCommentSuccess> = () => (
  {
    type: Types.CREATE_PROJECT_COMMENT_SUCCESS
  }
);

export const createProjectCommentFailure: ActionCreator<CreateProjectCommentFailure> = (error: {}) => (
  {
    type: Types.CREATE_PROJECT_COMMENT_FAILURE,
    payload: error
  }
);

export const createProjectComment: ActionCreator<CreateProjectCommentThunk> =
  (projectComment: ProjectComment, projectId: number): CreateProjectCommentThunk => {
    return (dispatch: Dispatch<RootState>): Promise<CreateProjectCommentAction> => {
      dispatch(createProjectCommentAttempt());

      return ApiClient.projectComment.create(projectComment, { projectId: projectId })
        .then((): CreateProjectCommentSuccess => {
          return dispatch(createProjectCommentSuccess());
        }).catch((e: { response: { data: { error: {} } } }): CreateProjectCommentFailure => {
          const errorMessages = ValidatorService
            .translateValidations(e && e.response && e.response.data && e.response.data.error);

          return dispatch(createProjectCommentFailure(errorMessages));
        });
    };
  };



// WEBPACK FOOTER //
// ./src/actions/project/comments/create/CreateProjectComment.actions.tsx